import React from 'react';
import { TextField, Paper, InputBase, IconButton, Divider } from '@mui/material';
import styled from '@emotion/styled';

import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

const StyledTextField = styled(TextField)``;

const SearchInput = ({ label = "Search", onChange, value = null, fieldsToSearch, disabled = false, refPointer }) => {
  let placeholder = label
  if (fieldsToSearch && fieldsToSearch.length) {
    placeholder = `Search by ${fieldsToSearch.join(", ")}`
  }
  return (
    <Paper
      component="form"
      variant='outlined'
      sx={{pl: '10px', display: "flex", alignItems: 'center', flexGrow: 1}}
    >
    <InputBase
      inputRef={refPointer}
      fullWidth
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      value={value}
    />
    <Divider orientation="vertical" sx={{ p: "2px 4px", height: "65%"}} />
      <IconButton type="button">
        <SearchRoundedIcon />
      </IconButton>
    </Paper>
  );
};

export default SearchInput;
